import { connect } from 'react-redux';
import Router from 'next/router';
import urlsService from '@/services/urls-service';
import { SortOrder } from '../Components/SortOrder';
import { selectSortOrder } from '../stores/selectors';
import { getProducts } from '../stores/productSearchSlice';

export const mapStateToProps = (state: any, ownProps?: any) => {
  const items = selectSortOrder(state);

  return {
    ...ownProps,
    items: items?.length > 0 ? items : []
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateSortOrder: (item: any) => {
      const apiUrl = urlsService.getUrl(item.urlSet.api);
      getProducts(dispatch)({ apiUrl });

      const nextUrl = `${document.location.origin}${item.urlSet.web}`;
      Router.push(nextUrl);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SortOrder);
